// one tinted panel with the steps listed below each other, subtle on the beige section
// so it doesn't compete with the white form card
.panel {
  padding: 1.25rem 1.5rem;
  background: color-mix(in srgb, var(--beigelight) 60%, white);
  border-radius: 12px;
}

.steps {
  display: flex;
  flex-direction: column;
  gap: .75rem;
  margin: 0;
  padding: 0;
  list-style: none;
}

.footer {
  margin-top: 1.5rem;
}

.step {
  display: flex;
  align-items: flex-start;
  gap: .75rem;
  line-height: 1.625rem;
}

.number {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 1.625rem;
  height: 1.625rem;
  border: 1px solid color-mix(in srgb, var(--primary) 35%, transparent);
  border-radius: 50%;
  color: var(--primary);
  font-size: .85em;
  font-weight: 600;
}
